import { render, staticRenderFns } from "./HorseCategorie.vue?vue&type=template&id=452b11e3&"
import script from "./HorseCategorie.vue?vue&type=script&lang=js&"
export * from "./HorseCategorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports